import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResourcePipe } from '@shared/pipes/resource.pipe';
import { Globals } from '@system/globals';

@Component({
  selector: 'app-assignment-status-sticker',
  templateUrl: './assignment-status-sticker.component.html',
  imports: [ResourcePipe, AsyncPipe],
})
export class AssignmentStatusStickerComponent {
  @Input() statusId: string;

  globals = Globals;
}
